import { StoreLocator } from '@components/store-locator/models';
import { Block } from '@shared/models';

export const storeLocatorMock = (withCta = false): Block<StoreLocator> => ({
  type: 'store-locator',
  data: {
    title: {
      text: `Je prends rendez-vous avec [[mon magasin]]`,
      as: 'span',
    },
    hasAppointmentCta: withCta,
    gtmConfigSelectStoreButton: {
      event: 'search_magasin_tunnel_rdv',
      group: 'rdv',
      description: 'etape 1 rdv',
      context: 'recherche magasin via moteur et validation',
    },
  },
});
